import React from 'react';

import { UseMutationConfig, useMutation } from 'react-relay';
import { GraphQLTaggedNode, MutationParameters } from 'relay-runtime';

// Util for promisfy-ing react-relay's useMutation/commit pattern
// NOTE: using react-relay's built-in useMutation and commitMutation is still preferred if Promises are not needed
// Inspired by: https://github.com/facebook/relay/issues/1822
export const useAsyncMutation = <T extends MutationParameters>(
  mutation: GraphQLTaggedNode,
): [(config: UseMutationConfig<T>) => Promise<T['response']>, boolean] => {
  const [commit, isInFlight] = useMutation<T>(mutation);

  const commitPromise = React.useCallback(
    async (config: UseMutationConfig<T>): Promise<T['response']> => {
      return await new Promise((resolve, reject) => {
        commit({
          ...config,
          onCompleted: (response) => resolve(response),
          onError: (e) => reject(e),
        });
      });
    },
    [commit],
  );

  return [commitPromise, isInFlight];
};
